module.exports = __webpack_public_path__ + "static/media/Surrounding3.e71cb006.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Surrounding3.jpeg
// module id = 576
// module chunks = 0